module.exports = __webpack_public_path__ + "img/icon-duplicate.bf77c7f9.svg";